import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Link } from "react-router-dom";
import * as PR from "../../prime-modules/index";
import "../maintenance/Maintenance.scss";
import { useDispatch, useSelector } from "react-redux";
import { getCountriesList, notifyemail } from "../../services/api";
import * as Yup from 'yup'
import { useFormik } from "formik";
import getAssets from '../../assets/data/brandingAssets.json';
import { useToast } from "../../context/ToastContext";

const Maintenance = () => {
  const dispatch = useDispatch();
  const { showToast, validations, labels, general, isBase64Image} = useToast()

  const [count, setCount] = useState(0);
  const [disableBtn, setDisableBtn] = useState(false);
  const siteMaintenance = useSelector(state => state.sitemaintenance.sitemaintenanceInfo);
  const isUnderMaintenance = (siteMaintenance === 'true') ? true : false;
  const affiliateTrackingData = useSelector(state => state.affiliateTracking.affiliateTrackingInfo);
  const headers = useMemo(() => {
      return {afid: affiliateTrackingData };
  }, [affiliateTrackingData]);

  const getCountries = useCallback(async () => {
    getCountriesList("countries", headers, dispatch, (response) => {
    })
  }, [dispatch, headers])

  useEffect(() => {
    isUnderMaintenance && getCountries();
  }, [getCountries, isUnderMaintenance])

  useEffect(() => {
    const timerId = setTimeout(() => {
      setCount(count + 1); // Update state using setCount
      isUnderMaintenance && getCountries();
    }, 10000);

    return () => {
      clearTimeout(timerId); // Cleanup the timeout on component unmount
    };
  }, [getCountries, isUnderMaintenance, count])


  const formInitialValues = {
    email: "",
  }

  const validationSchema = () => {
    return Yup.object().shape({
      email: Yup.string().trim()
        .email(validations.VLD0006)
        .required(validations.VLD0005)
    });
  }

  const submitHandler = (formData) => {
    setDisableBtn(true);
    const getResponse = (response) => {
      if (response.result === "SUCCESS") {
        showToast('success', 'GNRMSG-09')
        formik.resetForm();
      } else {
        const error = response.error;
        showToast(error.severity, error.errorMsg);
      }
      setDisableBtn(false);
    }
    const emailVal = formData.email.trim();
    const emailRequest = {
      email: emailVal
    }
    notifyemail(emailRequest, headers, dispatch, getResponse)
  }

  const formik = useFormik({
    initialValues: formInitialValues,
    validationSchema: validationSchema,
    onSubmit: submitHandler
  });


  return (
    <HelmetProvider>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{`${general.GEN0001} | ${labels.LBL0140}`}</title>
      </Helmet>
      {/* Header Section */}
      <section className="header-section maintenance-section">
        <div className="header">
          <header className="header-navigation">
            <Link to="/"><PR.Image src={isBase64Image(general.GEN0002) ? `data:image/png;base64,${general.GEN0002}` : getAssets.logo.logo_dark} className="esim-icon" alt="eSIM Icon" /></Link>
          </header>
        </div>
        <div className="grid header-text">
          <div className="col-12 md:col-10 lg:col-7">
            <div className="header-text-box">
              <h1><span>{labels.LBL0141}</span> {labels.LBL0140}</h1>
              <p>{labels.LBL0142}</p>
              <div className="email-block">
                  <form onSubmit={formik.handleSubmit}>
                    <PR.InputText id="email" name="email" value={formik.values.email} placeholder={labels.LBL0010} onChange={formik.handleChange} onBlur={formik.handleBlur} className="w-12" autoComplete="off" />
                    <PR.Button className="send-button p-button-rounded" icon="pi pi-envelope" disabled={disableBtn}/>
                    {formik.touched.email && formik.errors.email &&
                     <div className='error-message'>{formik.errors.email}</div>
                    }
                  </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </HelmetProvider>
  );
};

export default Maintenance;